export default __webpack_public_path__ + "static/media/poligrafia.03f0d832.jpg";